import React, { useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';
import { FiLogOut } from 'react-icons/fi';
import { AppContext } from '../../AppContext';
import { sidebarCollapsedAtom } from '../../atoms/uiAtom';

// 접히는 컨테이너 (헤더 햄버거와 상태 공유)
const Container = styled.aside`
  flex: 0 0 auto;
  width: ${(p) => (p.$collapsed ? '0px' : '15rem')};
  overflow: hidden;
  transition: width 0.25s ease;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  background: linear-gradient(135deg, #f9f9f9, #e9e9e9);
`;

// 접힘 애니메이션 중 내용이 찌그러지지 않도록 고정폭 내부 래퍼
const Inner = styled.div`
  width: 15rem;
  min-height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const StyledList = styled.ul`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 30px;
  margin: 0px;
  color: #000;
`;

const ListItem = styled.li`
  padding: 10px;
  margin: 10px 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  font-weight: 900;
  list-style-type: none;
  &:hover {
    background-color: #f0f0f0;
    transform: translateX(5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
`;

const StyledNavLink = styled(NavLink)`
  color: #333;
  text-decoration: none;
  display: block;
  &.active {
    font-weight: bold;
    color: #0056b3;
  }
`;

// 하단 고정 로그아웃 영역
const LogoutBox = styled.div`
  flex: 0 0 auto;
  padding: 16px 20px 22px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
`;

const LogoutButton = styled.button`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid #e5727d;
  border-radius: 10px;
  background: #fff;
  color: #d92d20;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
  & svg {
    width: 16px;
    height: 16px;
  }
  &:hover {
    background: #d92d20;
    color: #fff;
  }
`;

export default function SubNavigator({ links }) {
  const { logout } = useContext(AppContext);
  const navigate = useNavigate();
  const collapsed = useRecoilValue(sidebarCollapsedAtom);

  const handleLogout = async () => {
    try {
      const response = await fetch('/request/logout', { credentials: 'include', method: 'GET' });
      if (response.ok) {
        logout();
        sessionStorage.removeItem('user');
        navigate('/login');
      } else {
        console.error('Failed to logout');
      }
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <Container $collapsed={collapsed}>
      <Inner>
        <StyledList>
          {links.map((link, index) => (
            <ListItem key={index}>
              <StyledNavLink to={link.path}>{link.label}</StyledNavLink>
            </ListItem>
          ))}
        </StyledList>

        <LogoutBox>
          <LogoutButton onClick={handleLogout}>
            <FiLogOut /> 로그아웃
          </LogoutButton>
        </LogoutBox>
      </Inner>
    </Container>
  );
}
